import { createFileRoute } from "@tanstack/react-router";
import VirtualEducationPage from "@/pages/VirtualEducationPage";

const URL = "https://neurowellnesstms.com/virtual-education";

// Kept live for the webinar audience, but noindex + removed from the
// sitemap so it can't compete with /learn/what-is-saint-tms in Google.
export const Route = createFileRoute("/virtual-education/saint-tms-explained")({
  head: () => ({
    meta: [
      { name: "robots", content: "noindex, follow" },
      { title: "SAINT\u00ae TMS Explained Video | Neuro Wellness TMS" },
      {
        name: "description",
        content:
          "Watch SAINT\u00ae TMS Explained: a virtual education video from Neuro Wellness in Coral Springs, FL. Learn how 5-day fMRI-guided TMS treats depression.",
      },
      {
        property: "og:title",
        content: "SAINT\u00ae TMS Explained Video | Neuro Wellness TMS",
      },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <VirtualEducationPage />;
}
